import { render, staticRenderFns } from "./relation.vue?vue&type=template&id=fde46e3a&scoped=true&"
import script from "./relation.vue?vue&type=script&lang=js&"
export * from "./relation.vue?vue&type=script&lang=js&"
import style0 from "./relation.vue?vue&type=style&index=0&id=fde46e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde46e3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fde46e3a')) {
      api.createRecord('fde46e3a', component.options)
    } else {
      api.reload('fde46e3a', component.options)
    }
    module.hot.accept("./relation.vue?vue&type=template&id=fde46e3a&scoped=true&", function () {
      api.rerender('fde46e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/relation.vue"
export default component.exports